import 'leaflet/dist/leaflet.css';
import axios from "axios";
import React, { useState, useRef, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Polyline, Tooltip} from 'react-leaflet';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster';
import 'react-leaflet-markercluster/dist/styles.min.css';
import { position, icon100pab, icon3k, icon30k, icon100k, iconKp } from './constants/MapConstants';
import 'react-leaflet-markercluster/dist/styles.min.css';
import { getColor,calculateLines, lineColors, getPairStats} from '../AutoTopology/FunctionAutoTopology';
import { sampleCanton } from '../AutoTopology/FunctionLoadingData';
import Select from 'react-select';
import './styleAutoTopology.css';
import { GET_REGION_API_URL, GET_AREA_API_URL, GET_EQUIPMENT_AUTO_TOPOLOGY_API_URL, NETSTAT_SWITCH_URL} from '../Optics/OpticApiConfig';
import { iconSummit } from '../Optics/Constants/ConstantsOptics';
import L from 'leaflet';
import { useMemo } from "react";
import AutoTopologySidebar from './AutoTopologySidebar';
import SwitchMarker from './SwitchMarker';
import LinkInfoModal from './LinkInfoModal';

const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff',
    marginBottom: '5px',
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),

};

const Map2 = () => {
  const [switches, setSwitches] = useState([]);
  const [vetka, setVetka] = useState('');
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [position2, setPosition2] = useState([0, 0]); 
  const mapRef = useRef(null); 
  const [canton, setCanton] = useState([]);
  const [selectedCanton, setSelectedCanton] = useState([]);
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const selectedRegionRef = useRef(null);
  const [zoomLevel, setZoomLevel] = useState(null);


  const [area, setArea] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);
  const selectedAreaRef = useRef(null);

  const token = localStorage.getItem('token');


   useEffect(() => {
      const handleZoomChange = () => {
        if (mapRef.current) { 
          const newZoom = mapRef.current.getZoom();
          setZoomLevel(newZoom);
         
        }
      };
  
      if (mapRef.current) { 
        const map = mapRef.current;
        setZoomLevel(map.getZoom()); 
        map.on('zoomend', handleZoomChange); 
        return () => {
          map.off('zoomend', handleZoomChange);
        };
      }
    }, []);

  useEffect(() => {
    sampleCanton(setCanton);  
  }, []); 
  const [layersVisibility, setLayersVisibility] = useState({
    icon100pab: true,
    iconKp: true,
    icon3k: true,
    icon30k: true,
    icon100k: true,
  });

  const [linesVisibility, setLinesVisibility] = useState({
    blue: true,
    blue2: true,
    purple: true,
    green: true,
    brown: true,
    red: true,
    red2: true,
    black: true,
    orange: true,
    orange2: true
  });

  

const fetchData = async () => {
  const selectedRegion = selectedRegionRef.current.value;
  const selectedArea = selectedAreaRef.current.value;
  setVetka(selectedCanton);
  setSwitches([]);
  setLoading(true);
  
  try {
    if (selectedCanton === "null") {
      console.error("Выберите округ!");
      return;
    }

    let apiUrl = `${GET_EQUIPMENT_AUTO_TOPOLOGY_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;
    
    const result = await axios.get(apiUrl, {
      headers: {
          'Authorization': `Bearer ${token}`
      },
      onDownloadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          const percentCompleted = Math.round((loaded * 100) / total);
          setProgress(percentCompleted);
      }
  });
    // const result = await axios.get(apiUrl, {
    //   onDownloadProgress: (progressEvent) => {
    //     const { loaded, total } = progressEvent;
    //     const percentCompleted = Math.round((loaded * 100) / total);
    //     setProgress(percentCompleted);
    //   }
    // },{
    //   headers: {
    //     'Authorization': `Bearer ${token}`
    // }
    // });

    const { latitude, longitude } = result.data[0];
    setPosition2([latitude, longitude]);
    setSwitches(result.data);
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    setLoading(false);
    setProgress(0);
  }
};

  const toggleLayerVisibility = (layer) => {
    setLayersVisibility(prevState => ({
      ...prevState,
      [layer]: !prevState[layer],
      
    }));
  };
  const toggleLineVisibility = (layer) => {
    setLinesVisibility(prevState => ({
      ...prevState,
      [layer]: !prevState[layer],
    }));
  };

  async function fetchRegionsData(canton) {
    if (!canton) {  
      return;
    }
    try {
      const resultRegions = await axios.get(`${GET_REGION_API_URL}?canton=${canton}`,{
        headers: {
          'Authorization': `Bearer ${token}`
      }
      });
      return resultRegions.data;
    } catch (error) {
      console.error("Error fetching regions data:", error);
      return null;
    }
  }

  async function fetchAreaData(region) {
    try {
      const resultArea = await axios.get(`${GET_AREA_API_URL}?region=${region}`, {
        headers: {
          'Authorization': `Bearer ${token}`
      }
      });
      return resultArea.data;
    } catch (error) {
      console.error("Error fetching Area data:", error);
      return null;
    }
  }


  async function handleCantonChange(selectedOption) {
    setSelectedCanton(selectedOption.value);
       const regionsData = await fetchRegionsData(selectedOption.value);

    if (regionsData) {
      setRegions(regionsData);
    }
  }

 
  async function handleRegionChange(event) {
    const selectedRegion = event.target.value;
    setSelectedRegion(selectedRegion);
    const areaData = await fetchAreaData(selectedRegion);
    if (areaData) {
      setArea(areaData);
    }
  }


  const handleAreaChange = (event) => {
    const selectedArea = event.target.value;
    setSelectedArea(selectedArea);
  };
  


  useEffect(() => {
    fetchData();
  }, []); 

  useEffect(() => {
    // Обновление центра карты после изменения position2
    if (position2[0] !== 0 || position2[1] !== 0) {
      mapRef.current.setView(position2, 13);
    }
  }, [position2]); // Эффект срабатывает при каждом изменении position2


  const handleClick = () => {
    fetchData();
  };

 
// getColor();
 const lines = calculateLines(switches);








 
  return (
    <div style={{ display: 'flex', alignItems: 'normal', background: "linear-gradient(to bottom, #4b4b4b, #797979)" } } className={`map-container ${loading ? 'loading' : ''}`}>
      <AutoTopologySidebar
        canton={canton}
        selectedCanton={selectedCanton}
        handleCantonChange={handleCantonChange}
        regions={regions}
        selectedRegionRef={selectedRegionRef}
        handleRegionChange={handleRegionChange}
        area={area}
        selectedAreaRef={selectedAreaRef}
        handleAreaChange={handleAreaChange}
        handleClick={handleClick}
        loading={loading}
        layersVisibility={layersVisibility}
        toggleLayerVisibility={toggleLayerVisibility}
        linesVisibility={linesVisibility}
        toggleLineVisibility={toggleLineVisibility}
        customStyles={customStyles}
      />
    <div className='mapAutoTopology'>

      <LinkInfoModal/>

      <MapContainer ref={mapRef} center={[50.4501,30.5245]} zoom={13} className='mapAutoTopology' style={{ height: '100vh', width: '100%', borderRadius: '10px' }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          maxZoom={19.5} 
        />
  
          {switches.map((coordinate, index) => (
            <SwitchMarker
              key={index}
              coordinate={coordinate}
              switches={switches}
              zoomLevel={zoomLevel}
              layersVisibility={layersVisibility}
            />
          ))}


        {lines.map((line, index) => 
        linesVisibility[line.color] && (
          <Polyline
            key={index}
            positions={line.positions}
            pathOptions={{ color: lineColors[line.color], weight: 2 }}
          />
        )
      )}
</MapContainer>
  </div>
</div>
  );      
};

export default Map2;
